import DashboardTargetRecord from './DashboardTargetRecord';
import { useAct } from 'DashboardUser/store';
import { Backdrop } from '@material-ui/core'

export default function RecordModal() {
  const act = useAct();
  const dashboardTargetId = useSel(s => s.local.expandedDashboardTargetId);
  const [isModalOpen, setIsModalOpen] = useState(!!dashboardTargetId);

  function close() {
    setIsModalOpen(false);
    setTimeout(() => { //Delay the upsert to allow the modal to fade out
      act.local.upsert({ expandedDashboardTargetId: null });
    }, 200);
  }
  const name = useSel(s => {
    const dashboardTarget = s.dashboardTargets.entities[dashboardTargetId];
    console.log(s.dashboard.dashboardFields);
    const nameField = s.dashboard.dashboardFields.find(f => f.source === 'column' && f.name === 'Name');

    if (!nameField) return 'Record';

    return dashboardTarget[nameField.id] || 'Record';
  })

  return <Backdrop open={isModalOpen} classes={{ root: 'cc-backdrop' }} onClick={close}>
      <div onClick={(e) => e.stopPropagation()} className="dashboard-record-modal">
        <div className="dashboard-record-modal-header">
          <h2>{name}</h2>
          <button className="dashboard-record-modal-close" onClick={close} aria-label="Close modal" type="button">
            <SvgIconsClose className="no-margin" />
          </button>
        </div>
        <div className="dashboard-record-modal-content">
        <DashboardTargetRecord dashboardTargetId={dashboardTargetId} />
        </div>
        <div className="dashboard-record-modal-footer">
          <button className="button primary" onClick={close}>
            Done
          </button>
        </div>
      </div>
    </Backdrop>
}
